import { useQueryState } from "nuqs";
import { WIDGETS_SEARCH_QUERY_PARAM_NAMES } from "@/components/shared/widgets/constants";
import { useCallback } from "react";
import { ContactDetailI } from "shared/lib/interfaces/account";

export const useLeadsSection = () => {
  const [contactId] = useQueryState(
    WIDGETS_SEARCH_QUERY_PARAM_NAMES.CONTACT_ID
  );

  /**
   * Filter function to exclude the targeted contact from the leads section
   *
   * @param contact - Contact detail
   * @returns True if the contact is not the targeted contact, false otherwise
   */
  const filterFunc = useCallback(
    (contact: ContactDetailI) => contact.id !== contactId,
    [contactId]
  );

  return {
    contactId,
    filterFunc: contactId ? filterFunc : undefined,
  };
};
